import { render, staticRenderFns } from "./dslyBeingOverdue.vue?vue&type=template&id=d32d0a04"
import script from "./dslyBeingOverdue.vue?vue&type=script&lang=js"
export * from "./dslyBeingOverdue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports